/**
 * @file Basic Controller
 */

 'use strict';
 import Listener from '../Utils/Listener';
 import BasicModel from '../Model/BasicModel';
 import Common  from '../Utils/Common';

 let instance = null;

 /**
  * @classname Basic
  * @classdesc Basic Controller
  */
 export default class Basic {

     /**
      * @constructor
      */
     constructor() {
         if (instance) {
             return instance;
         }
         console.log('Basic.constructor');

         this._model = new BasicModel();

         this._listener = new Listener();

         this._model.on('completeGetFacilities', () => {
             this._data = this._model._data;
             this._listener.trigger('completeGetFacilities');
         });

         this._model.on('completeGetArticles', () => {
             this._data = this._model._data;
             this._listener.trigger('completeGetArticles');
         });

         instance = this;
         return instance;

     };


     /**
      * 施設取得
      *
      * @memberof Basic
      * @param {float} lat - 緯度
      * @param {float} lng - 経度
      * @return {undefined}
      */
     setLatLng(lat, lng) {
         console.log('Basic.getFacilities');
         this._lat = lat;
         this._lng = lng;
     };


     /**
      * 施設取得
      *
      * @memberof Basic
      * @param {integer} zoom - google map zoom
      * @return {undefined}
      */
     getFacilities(zoom) {
         console.log('Basic.getFacilities');
         let km;
         const count = 300;
         let category = null;
         let service = null;

         switch(zoom){
             case 16:
                 km = 2.3;
                 break;
             case 17:
                 km = 1;
                 break;
             case 18:
                 km = 0.7;
                 break;
             case 19:
                 km = 0.35;
                 break;
             case 20:
                 km = 0.2;
                 break;
             default:
                 km = 3;
                 break;
         }
         category = $('.btn--location-search').map((idx,e) => {
             const  $e = $(e);
             if($e.hasClass('active')) return $e.attr('data-category')
         }).get().join('|');
         if(category === '') category = null;

         service = $('.form-check-input:checked').map((idx, e) => {
            return $(e).val();
          }).get().join('|');
          if (service === '' || (category !== '1' && category !== '1|')) service = null;
         this._model.getFacilities(this._lat, this._lng, km, count, category, service);
     };


     /**
      * 施設取得
      *
      * @memberof Basic
      * @param {integer} page - ページ
      * @param {integer} type - 記事タイプ
      * @param (integer} count - 取得件数
      * @return {undefined}
      */
     getArticles(page, type, count = 18) {
         console.log('Basic.getArticles');
         this._model.getArticles(page, type, count);
     };


     /**
      * listener on
      *
      * @memberof Basic
      * @param {string} name - イベント名
      * @param {function} fn - 実行する関数
      * @return {undefined}
      */
     on(name, fn) {
         this._listener.on(name, fn);
     };


     /**
      * listener off
      *
      * @memberof Basic
      * @param {string} name - イベント名
      * @param {function} fn - 実行する関数
      * @return {undefined}
      */
     off(name, fn) {
         this._listener.off(name, fn);
     };
 }
